// extracted by mini-css-extract-plugin
export default {"contact":"Home_contact__52obF"};